import Box from "@mui/material/Box"
import { styled } from "@mui/material/styles"

const DraggingNodePriv = styled(Box)(({ theme }) => ({
  width: "200px",
  height: "80px",
  border: `1px dashed ${theme.palette.primary.main}`,
}))

export default function DraggingNode(props) {
  return <DraggingNodePriv />
}
